<template>
  <div
    class="tw-pt-0 tw-pb-4 tw-flex tw-items-start tw-gap-2"
  >
    <div class="tw-size-[15px] tw-mt-[2px] md:tw-mt-[6px]">
      <svg
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.93359 13.481C1.5332 13.481 1.18896 13.3955 0.900879 13.2246C0.612793 13.0537 0.390625 12.8218 0.234375 12.5288C0.078125 12.2407 0 11.916 0 11.5547C0 11.2129 0.090332 10.8857 0.270996 10.5732L5.63965 1.21289C5.82031 0.895508 6.05957 0.65625 6.35742 0.495117C6.65527 0.329102 6.96777 0.246094 7.29492 0.246094C7.61719 0.246094 7.92725 0.329102 8.2251 0.495117C8.52295 0.65625 8.76465 0.895508 8.9502 1.21289L14.3188 10.5732C14.4067 10.7344 14.4727 10.8979 14.5166 11.064C14.5654 11.23 14.5898 11.3936 14.5898 11.5547C14.5898 11.916 14.5117 12.2407 14.3555 12.5288C14.1992 12.8218 13.9771 13.0537 13.689 13.2246C13.4009 13.3955 13.0566 13.481 12.6562 13.481H1.93359ZM1.99951 12.2725H12.583C12.8125 12.2725 12.9932 12.1968 13.125 12.0454C13.2617 11.8989 13.3301 11.7256 13.3301 11.5254C13.3301 11.3789 13.2935 11.2397 13.2202 11.1079L7.91748 1.84277C7.84912 1.72559 7.75635 1.64014 7.63916 1.58643C7.52686 1.52783 7.41211 1.49854 7.29492 1.49854C7.17285 1.49854 7.05322 1.52783 6.93604 1.58643C6.81885 1.64014 6.72607 1.72559 6.65771 1.84277L1.3623 11.1006C1.32324 11.1689 1.29639 11.2422 1.28174 11.3203C1.26709 11.3936 1.25977 11.4619 1.25977 11.5254C1.25977 11.7256 1.32568 11.8989 1.45752 12.0454C1.58936 12.1968 1.77002 12.2725 1.99951 12.2725ZM7.29492 8.74951C6.91406 8.74951 6.71875 8.55664 6.70898 8.1709L6.61377 4.6626C6.60889 4.46729 6.66992 4.30859 6.79688 4.18652C6.92383 4.06445 7.0874 4.00342 7.2876 4.00342C7.48291 4.00342 7.64648 4.06689 7.77832 4.19385C7.91016 4.31592 7.97363 4.47461 7.96875 4.66992L7.86621 8.1709C7.85645 8.55664 7.66602 8.74951 7.29492 8.74951ZM7.29492 11.02C7.08496 11.02 6.90186 10.9492 6.74561 10.8076C6.59424 10.6611 6.51855 10.4854 6.51855 10.2803C6.51855 10.0752 6.59424 9.90186 6.74561 9.76025C6.89697 9.61377 7.08008 9.54053 7.29492 9.54053C7.50977 9.54053 7.69287 9.61133 7.84424 9.75293C8.00049 9.89453 8.07861 10.0703 8.07861 10.2803C8.07861 10.4902 8.00049 10.666 7.84424 10.8076C7.69287 10.9492 7.50977 11.02 7.29492 11.02Z"
          fill="#D24646"
        />
      </svg>
    </div>
    <div class="tw-text-[#D24646] tw-text-sm md:tw-text-lg">
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ErrorLabel'
};
</script>

<style scoped>

</style>

